import React from 'react';
import {Switch, Route} from 'react-router-dom';
import {Wrapper} from '../../components/common';
import Privacy from '../../components/Privacy';
import Terms from '../../components/Terms';

export default function PageContainer() {
  return (
    <Wrapper>
      <Switch>
        <Route path="/privacy" render={() => <Privacy/>}/>
        <Route path="/terms" render={() => <Terms/>}/>
      </Switch>
    </Wrapper>
  );
}
